// File: TrademarkServices.jsx
import React from "react";

export default function TrademarkServices() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Trademark Services
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides complete trademark lifecycle services.
          </p>
          <p className="text-gray-700">
            Full trademark services including registration (TM-A), renewal, objection responses, opposition proceedings, hearing representation, infringement protection, assignment/licensing, and Madrid Protocol international filings.
          </p>
        </div>

        {/* Right: Image (TRADEMARK SERVICES SPECIFIC) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/5066784/pexels-photo-5066784.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Comprehensive trademark services by Hawkins & Brooks"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for seamless trademark processes.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Trademark logo/design details</li>
                <li>Applicant identity proof (PAN/Aadhaar)</li>
                <li>Usage proof (invoices, packaging)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              IP law expertise and strategic trademark protection across all stages.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Complete IP Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Trade Marks Act 1999 knowledge including TM-A filing, class selection (45 classes), examination reports, objection responses (Form TM-M), oppositions (TM-O), hearing representation, renewal (TM-R), and Madrid international applications.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Strategic Protection
                </h3>
                <p className="text-gray-700 text-sm">
                  Strategic trademark portfolio management including prior searches, multi-class filings, objection countermeasures, opposition defense, infringement cease & desist, assignment documentation (TM-P), licensing agreements, and international protection strategy.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Services
                </h3>
                <p className="text-gray-700 text-sm">
                  Full trademark lifecycle from search & filing through examination, publication, oppositions, hearings, registration certificates, renewals, assignment transfers, infringement protection, and international Madrid Protocol applications.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
